import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import Clarity from "@microsoft/clarity";

export default function bootstrap(node, config) {
  if (config.clarityConfig?.enabled === true && config.clarityConfig.projectId) {
    Clarity.init(config.clarityConfig.projectId)
  }
  const root = createRoot(node); 
  root.render(<App {...config} />);
}
